// extracted by mini-css-extract-plugin
export default {"tableRow":"CandidateTable_tableRow__0FEDD","tableRowOpacity":"CandidateTable_tableRowOpacity__2AMgy","scoreCell":"CandidateTable_scoreCell__xXRG1"};